<template lang="pug">
  div#offerings
    v-card.imageTop(width="100%" height="400",dark)
      v-img(src="../assets/img/951182240.jpeg" height="100%"  )
        v-row(align="center" style="height:100%")
          v-col(cols="12" align="center")
            p.display-2.font-weight-black.offerings-title.info Give to City of Refuge
    v-container(  )
      router-view 
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.offerings-title
  font-family Cardo, 'san-serif' !important
  color var(--v-primary-base)
</style>
